import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const SecurityIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M8 9.3229L9.5 10.8229L12.5 7.8229M4 4.8229L8.65836 2.49372C9.50294 2.07143 10.4971 2.07143 11.3416 2.49372L16 4.8229C16 4.8229 16 9.2029 16 11.5129C16 13.8229 13.8647 15.3822 10 17.8229C6.13533 15.3822 4 13.3229 4 11.5129V4.8229Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
};

SecurityIcon.displayName = 'SecurityIcon';
